import { render, staticRenderFns } from "./MarketNotice.vue?vue&type=template&id=077846ec&scoped=true&"
import script from "./MarketNotice.vue?vue&type=script&lang=js&"
export * from "./MarketNotice.vue?vue&type=script&lang=js&"
import style0 from "./MarketNotice.vue?vue&type=style&index=0&id=077846ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077846ec",
  null
  
)

export default component.exports